import script from "./Materials.vue?vue&type=script&setup=true&lang=ts"
export * from "./Materials.vue?vue&type=script&setup=true&lang=ts"

import "./Materials.vue?vue&type=style&index=0&id=884304a6&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-884304a6"]])

export default __exports__